import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { Popover } from "@tql/ui-components-react/kendo/tooltip";
import { alertCircle } from "@tql/ui-components-react/untitled/icons";
import { useRef, useState } from "react";

type CarrierRoutingGuideInfoProps = {
	readonly carrierName: string;
	readonly ruleNames: readonly string[];
};

export const CarrierRoutingGuideInfo = ({
	carrierName,
	ruleNames,
}: CarrierRoutingGuideInfoProps) => {
	const anchorRef = useRef<HTMLSpanElement>(null);
	const [show, setShow] = useState(false);

	const rules = ruleNames.length > 0 ? ruleNames : ["N/A"];

	return (
		<>
			<span
				ref={anchorRef}
				onMouseEnter={() => setShow(true)}
				onMouseLeave={() => setShow(false)}
				role={"button"}
				style={{ display: "inline-flex" }}
				tabIndex={0}
			>
				<SvgIcon icon={alertCircle} size={"large"} />
			</span>
			<Popover
				anchor={anchorRef.current}
				animate={false}
				contentStyle={{ maxWidth: 350 }}
				popoverClass={"tql-popover"}
				position={"top"}
				show={show}
			>
				<div>
					{carrierName} originally filtered out due to Routing Guide Rule
					{rules.length === 1 ? "" : "s"}:
				</div>
				<ul style={{ margin: 0, paddingLeft: "1.25em" }}>
					{rules.map((name) => (
						<li key={name}>{name}</li>
					))}
				</ul>
			</Popover>
		</>
	);
};
